exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-border_{border-collapse:collapse}.table-border_,.table_w{font-family:arial,sans-serif;width:100%}.table-border_ td,th{border:1px solid #ddd;text-align:left;padding:8px}.table-border_ tr:nth-child(2n){background-color:#ddd}.table_w_{width:45%;font-family:arial,sans-serif;float:right}.block_right{text-align:end!important}", ""]);

// exports
